import { Autocomplete, Badge, Button, Checkbox, CircularProgress, FormControl, FormControlLabel, Grid, IconButton, Input, InputLabel, Link, MenuItem, Paper, Select, TextField, Typography } from "@mui/material";
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import APIManager from '../../lib/apiManager';
import EditorTest from "../EditorTest";
import WYSIWYGEditor from "../WYSIWYGEditor";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import { Stack } from '@mui/material';
import { Add, InsertDriveFile } from "@mui/icons-material";
import { sistema } from '../../model/Sistema';
import BeneficioCard from "./components/BeneficioCard";
import { Avatar } from '@mui/material';

const Beneficio = ({setBotonera, espacios}) => {

  const [beneficio, setBeneficio] = useState(null);
  const [active, setActive] = useState(false);

  const [editando, setEditando] = useState(false);

  const [espacio, setEspacio] = useState(null);

  const [esMaquinero, setEsMaquinero] = useState(false);
  const [empresa, setEmpresa] = useState('');
  const [titulo, setTitulo] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [descuento, setDescuento] = useState('');
  const [web, setWeb] = useState('');
  const [logo, setLogo] = useState('');
  const [places, setPlaces] = useState('');
  const [imagen, setImagen] = useState(null);
  const [imagenCambiada, setImagenCambiada] = useState(false);

  const [prestadores, setPrestadores] = useState([]);
  const [prestador, setPrestador] = useState(null);
  const [prestadorNombre, setPrestadorNombre] = useState('');

  const [habilitadoParaGuardar, setHabilitadoParaGuardar] = useState(false);

  const [ready, setReady] = useState(false);

  let { beneficioId } = useParams();

  const nuevoBeneficio = {
    id: null,
    empresa: '',
    titulo: '',
    descripcion: '',
    descuento: '',
    web: '',
    categorias: {},
    espacios: {},
    places: '',
    prestador: null,
    activo: false,
  };

  const botoneraDeBeneficio = [
    { title: 'Volver', label: 'Volver', variant: 'outlined', onClick: () => { navigate(-1); } },
    { title: 'Editar', label: 'Editar', variant: (editando ? 'outlined' : 'contained'), visible: !editando, onClick: () => { setEditando(!editando); } },
    { title: 'Cancelar', label: 'Cancelar', variant: 'outlined', visible: editando, onClick: () => { handleCancelar(); } },
    { title: 'Guardar', label: 'Guardar', variant: 'contained', visible: editando, disabled: !habilitadoParaGuardar, onClick: () => { handleGuardar(); } },
  ];

  const navigate = useNavigate();

  const cargarPrestadores = () => {
    APIManager.getList('prestadoresDeBeneficios', {activos: true}, (response) => {
      setPrestadores(response.data.listado);
    });
  }


  const editarBeneficio = () => {
    setEditando(!editando);
  }

  const toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

  const cambiarImagen = async (event) => {
    // setImagenCambiada(true);
    const imageFiles = event.target.files;
    if (imageFiles.length > 0) {
      const base64file = await toBase64(imageFiles[0]);
      const nuevaImagen = { file: base64file, name: imageFiles[0].name, tipo: 'logoDeBeneficio', id: beneficio.id, url: URL.createObjectURL(imageFiles[0]) };
      setImagen(nuevaImagen);
      setLogo(nuevaImagen.url);
      setImagenCambiada(true);
      setHabilitadoParaGuardar(true);
    }

  }

  const beneficioActualizado = () => {
    const miBeneficioActualizado = { ...beneficio };
    miBeneficioActualizado.empresa = empresa;
    miBeneficioActualizado.prestador = prestador;
    miBeneficioActualizado.titulo = titulo;
    miBeneficioActualizado.descripcion = descripcion;
    miBeneficioActualizado.descuento = descuento;
    miBeneficioActualizado.web = web;
    miBeneficioActualizado.logo = logo;
    miBeneficioActualizado.imagen = imagen;
    miBeneficioActualizado.logoURL = logo;
    miBeneficioActualizado.activo = active;
    miBeneficioActualizado.esMaquinero = esMaquinero;

    return miBeneficioActualizado;

  }

  const guardarBeneficio = () => {
    const beneficioAEnviar = beneficioActualizado();
    setHabilitadoParaGuardar(false);

    APIManager.sendRequest('post', 'beneficios', 'modificarBeneficio', { beneficio: beneficioAEnviar }, (response) => {
      if (response.success) {
        setEditando(false); // Se guardó y ya no estamos editando
        if (!beneficioAEnviar.id) {
          navigate(-1);
        } else {
          actualizarBeneficio();
        }
      }
    });

  }

  // const handleTipoDeBeneficio = (event) => {
  //   const tipo = event.target.value;
  //   setTipoDeBeneficioNombre(tipo.descripcion);
  //   setTipoDeBeneficio(tipo);
  //   setHabilitadoParaGuardar(true);
  // }

  const handleActive = (event) => {
    setActive(event.target.checked);
    setHabilitadoParaGuardar(true);
  }

  const handleEsMaquinero = (event) => {
    setEsMaquinero(event.target.checked);
    setHabilitadoParaGuardar(true);
  }

  const handleWeb = (event) => {
    setWeb(event.target.value);
    setHabilitadoParaGuardar(true);
  }

  const handlePlaces = (event) => {
    setPlaces(event.target.value);
    setHabilitadoParaGuardar(true);
  }

  const handleTitulo = (event) => {
    setTitulo(event.target.value);
    setHabilitadoParaGuardar(true);
  }

  const handleEmpresa = (event) => {
    setEmpresa(event.target.value);
    setHabilitadoParaGuardar(true);
  }

  const handlePrestador = (event, item) => {
    setPrestador(item);
    if (!!item?.nombre) {
      setPrestadorNombre(item.nombre);
    }
    setHabilitadoParaGuardar(true);
  }

  const handleDescripcion = (event) => {
    setDescripcion(event.target.value);
    setHabilitadoParaGuardar(true);
  }

  const handleDescuento = (event) => {
    setDescuento(event.target.value);
    setHabilitadoParaGuardar(true);
  }

  // const handleEmail = (event) => {
  //   setEmail(event.target.value);
  //   setHabilitadoParaGuardar(true);
  // }

  const handleGuardar = (event) => {
    guardarBeneficio();
  }

  const handleCancelar = (event) => {
    if (beneficioId == 'nuevo') {
      navigate(-1);
    } else {
      setEditando(!editando);
      actualizarBeneficio();
    }
  }

  // const handleChangeTipoDeBeneficio = () => {
  //   setReady(false);
  //   let nuevoBeneficio = null;
  //   nuevoBeneficio = beneficioFrom(beneficio, tipoDeBeneficio, referente);
  //   setBeneficio(nuevoBeneficio);
  // }

  const actualizarBeneficio = () => {
    if (beneficioId === "nuevo") {
      // Es uno nuevo
      const miNuevoBeneficio = Object.assign({}, nuevoBeneficio);
      setBeneficio(miNuevoBeneficio);
      setEditando(true);
    } else {
      // Vino beneficioId, obtenemos el beneficio
      const postData = {};
      postData.id = beneficioId;

      APIManager.sendRequest('post', 'beneficios', 'getBeneficio', postData, (response) => {
        if (response.success) {
          setBeneficio(response.data.beneficio);
        }
      });
    }
  }

  useEffect(() => {

    if (!!beneficioId) {
      cargarPrestadores();
      actualizarBeneficio();

      // APIManager.sendRequest('post','ui','getTiposDeBeneficio', {}, (response) => {
      //   if (response.success) {
      //     setTiposDeBeneficio(response.data);
      //   }
      // })
    }

  }, [beneficioId]);

  useEffect(() => {
    if (!!beneficio) {
      sistema.actual.beneficio = beneficio;
      setEmpresa(beneficio.empresa);
      setTitulo(beneficio.titulo ?? beneficio.nombre);
      setWeb(beneficio.web);
      setDescripcion(beneficio.descripcion);
      setDescuento(beneficio.descuento);
      setActive(beneficio.activo);
      setEsMaquinero(beneficio.is_maquinero);
      setLogo(beneficio.logoURL);
      setPlaces(beneficio.places);
      // const nuevoEspacio = espacios.find((item) => {
      //   if (!!beneficio.espacio) {
      //     return item.id === beneficio.espacio.id;
      //   } else {
      //     return item.id === sistema.espacio.id;
      //   }
      // });
      // setEspacio(nuevoEspacio);
    }
  }, [beneficio]);
/*
  useEffect(() => {
    if (!!beneficio && (!!membresias.length > 0)) {
      let membresiaID;
      if (!!beneficio.membresia) {
        membresiaID = beneficio.membresia.id;
      } else {
        membresiaID = membresias[0].id;
      }
      setMembresia(membresias.find((item) => { return item.id === membresiaID }));
    }
  }, [beneficio, membresias]);
 */
/*
  useEffect(() => {
    // console.log('useEffect: referente');
    if (!!referente) {
      if (beneficio.tipo === 'EMPRESA') {
        // console.log('Empresa:', referente);
        setEmpresa(referente);
        if (!!referente.usuarioPrincipal) {
          setMiembro(referente.usuarioPrincipal);
        }
        if (!email && !!referente.usuarioPrincipal) {
          setEmail(referente.usuarioPrincipal.emailDeContacto);
        }
      } else {
        // console.log('Miembro:', referente);
        setMiembro(referente);
        if (!email && !!referente) {
          setEmail(referente.emailDeContacto);
        }
      }
    }
    setReady(true);
  }, [referente]);
 */
/*
  useEffect(() => {
    if (!tipoDeBeneficio) {
      if (!!beneficio && (tiposDeBeneficio.length > 0)) {
        setTipoDeBeneficio(tiposDeBeneficio.find(item => item.tipo === beneficio.tipo));
      }
    }
  }, [beneficio, tiposDeBeneficio]);
 */
/*
  useEffect(() => {
    if (!!tipoDeBeneficio && (tipoDeBeneficio.tipo !== beneficio.tipo)) {
      handleChangeTipoDeBeneficio();
    }
  }, [tipoDeBeneficio]);
 */

  useEffect(() => {
    if (!!beneficio && !!prestadores && (!!prestadores.length > 0)) {
      if (!!beneficio.prestador) {
        setPrestador(prestadores.find(item => item.id === beneficio.prestador.id));
      }
    }
  }, [beneficio, prestadores]);

  useEffect(() => {
    setBotonera(botoneraDeBeneficio);
  }, [habilitadoParaGuardar, titulo, esMaquinero, active, editando, empresa, imagenCambiada, imagen, logo, descuento, descripcion, web]);

  return (
    <Paper sx={{ padding: '14px' }}>
      {!!beneficio
        ? <Grid container spacing={2}>
          <Grid container item spacing={2} xs={10}>
            <Grid item xs={2}>
              <FormControl variant="standard">
                <InputLabel id="id-label" >ID</InputLabel>
                <Input
                  disabled={true}
                  labelId="id-label"
                  id="id-input"
                  value={((!!beneficio && !!beneficio.id) ? beneficio.id : '') + (!!beneficio && !!beneficio.id && !!beneficio.beneficio_id ? ' :: ' : '') + (!!beneficio && !!beneficio.beneficio_id ? beneficio.beneficio_id : '')}
                >
                </Input>
              </FormControl>
            </Grid>
            <Grid item xs={2}>
              <FormControlLabel label="Activo" control={
                <Checkbox disabled={!editando} checked={active} onChange={handleActive} />
              } />
            </Grid>
            <Grid item xs={2}>
              <FormControlLabel label="Es Maquinero" control={
                <Checkbox disabled={!editando} checked={esMaquinero} onChange={handleEsMaquinero} />
              } />
            </Grid>
            <Grid item xs={2}>
              <FormControlLabel label="Logo"
                disabled={!editando}
                control={
                  <>
                    <input accept="image/*" style={{display: 'none'}} type="file" disabled={!editando} onChange={cambiarImagen} />
                    <Badge sx={{ margin: "10px" }} overlap="circular" color="primary"
                      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                      badgeContent={<Add sx={{ width: 12, height: 12, padding: 0 }} />}>
                      <Avatar src={logo} alt={titulo} sx={{width: "100px", height: "100px"}} />
                    </Badge>
                  </>
              } />
            </Grid>
            <Grid item xs={6}>
              <FormControl variant="standard" fullWidth>
                <InputLabel id="empresa-label" >Empresa</InputLabel>
                <Input
                  disabled={!editando}
                  id="empresa-input"
                  value={empresa}
                  onChange={handleEmpresa}
                  required
                >
                </Input>
              </FormControl>
            </Grid>
            {/* <Grid item xs={6}>
              <FormControl variant="standard" fullWidth>
                <InputLabel id="prestador-label" >Prestador</InputLabel>
                <Input
                  disabled={!editando}
                  id="prestador-input"
                  value={prestador}
                  onChange={handlePrestador}
                  required
                >
                </Input>
              </FormControl>
            </Grid> */}
            <Grid item sm={6}>
              <Autocomplete
                id="prestador-input"
                options={prestadores}
                value={prestador}
                onChange={handlePrestador }
                getOptionLabel={item => item?.nombre ?? prestadorNombre}
                sx={{ width: "100%" }}
                disabled={!editando}
                // isOptionEqualToValue={(item, value) => (item === value) || (item?.id == value)}
                renderInput={(params) =>
                  <TextField variant="standard" {...params} label="Prestador" />
                }
                title={prestador?.nombre}
              />
              {/* <FormControl variant="standard" sx={{ width: "100%" }}>
                {((!!prestadores && (prestadores.length > 0)) ?
                  <>
                    <InputLabel id="prestador-label">Prestador</InputLabel>
                    <Select
                      labelId="prestador-label"
                      id="prestador-select"
                      value={prestador}
                      onChange={handlePrestador}
                      label="Prestador"
                      disabled={!editando}
                    >
                      {prestadores.map(
                        (item => <MenuItem value={item}>{item.nombre}</MenuItem>)
                      )}
                    </Select>
                  </>
                  : <Stack direction="row" alignItems="center">
                    <Typography>Cargando prestadores...</Typography>
                    <CircularProgress labelId="cliente-label" />
                  </Stack>)
                }
              </FormControl> */}
            </Grid>
            <Grid item xs={6}>
              <FormControl variant="standard" fullWidth>
                <InputLabel id="titulo-label" >Titulo</InputLabel>
                <Input
                  disabled={!editando}
                  id="titulo-input"
                  value={titulo}
                  onChange={handleTitulo}
                  required
                >
                </Input>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl variant="standard" fullWidth>
                <InputLabel id="cuit-label" >Descuento</InputLabel>
                <Input
                  disabled={!editando}
                  labelId="web-label"
                  id="web-input"
                  value={descuento}
                  onChange={handleDescuento}
                >
                </Input>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl variant="standard" fullWidth>
                <InputLabel id="cuit-label" >WEB</InputLabel>
                <Input
                  disabled={!editando}
                  labelId="web-label"
                  id="web-input"
                  value={web}
                  onChange={handleWeb}
                >
                </Input>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl variant="standard" fullWidth>
                <InputLabel id="cuit-label" >Ubicacion</InputLabel>
                <Input
                  disabled={!editando}
                  labelId="web-label"
                  id="web-input"
                  value={places}
                  onChange={handlePlaces}
                >
                </Input>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl variant="standard" fullWidth>
                {/* <InputLabel id="cuit-label" >Descripción</InputLabel> */}
                <TextField
                  disabled={!editando}
                  label="Descripción"
                  id="web-input"
                  value={descripcion}
                  variant="standard"
                  onChange={handleDescripcion}
                  multiline
                >
                </TextField>
              </FormControl>
            </Grid>
          </Grid>
          {/* <Grid item xs={12} sm={2} >
            <FormControl variant="standard">
              <InputLabel id="tipoDeBeneficio-label" shrink={true} >Tipo de Beneficio</InputLabel>
              <Select
                // labelId="tipoDeBeneficio-label"
                id="tipoDeBeneficio-select"
                value={tipoDeBeneficio}
                onChange={handleTipoDeBeneficio}
                label="Tipo de Beneficio"
                disabled={!editando && (beneficioId !== 'nuevo')}
              >
                {tiposDeBeneficio.map(
                  (tipo => <MenuItem value={tipo}>{tipo.descripcion}</MenuItem>)
                )}
              </Select>
            </FormControl>
          </Grid> */}
          {/* <Grid item xs={12} sm={4}>
            <FormControl variant="standard" fullWidth>
              <InputLabel id="razonSocial-label" >Razon Social</InputLabel>
              <Input
                disabled={!editando}
                labelId="razonSocial-label"
                id="razonSocial-input"
                value={razonSocial}
                onChange={handleRazonSocial}
                required
              >
              </Input>
            </FormControl>
          </Grid> */}
          {/* <Grid item xs={12} sm={2}>
            <FormControl variant="standard">
              <InputLabel id="cuit-label" >CUIT</InputLabel>
              <Input
                disabled={!editando}
                labelId="cuit-label"
                id="cuit-input"
                value={cuit}
                onChange={handleCuit}
                required
              >
              </Input>
            </FormControl>
          </Grid> */}
          <Grid item xs={2}>
            <InputLabel id="preview-label" >Vista preliminar</InputLabel>
            <BeneficioCard {...beneficioActualizado()} />
          </Grid>
          {/* <Grid item xs={12} sm={4}>
            <FormControl variant="standard" fullWidth>
              <InputLabel id="email-label" >Email de contacto</InputLabel>
              <Input
                disabled={!editando}
                labelId="email-label"
                id="email-input"
                value={email}
                onChange={handleEmail}
                required
              >
              </Input>
            </FormControl>
          </Grid> */}
        </Grid>
        : <>{ 'No hay datos del beneficio' }</>
      }
    </Paper>
  )
}

export default Beneficio;